// @flow

import React from "react";
import "./chat-bubble.style.scss";

type Props = $Exact<{
  message: string | null,
}>;

export const ChatBubble = (props: Props) =>
  props.message &&
  props.message.length > 0 && (
    <div className="chat-bubble">
      <div className="speech-bubble px-3 py-3 text-grey">{props.message}</div>
    </div>
  );

export default ChatBubble;
